/**
 * ReferralSettings - Main referral settings page component
 * Composed of modular sub-components using the referral store
 */
import React, { useEffect } from "react";
import { Alert, Skeleton, Stack } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";
import { useReferralStore } from "@/stores/referralStore";
import { ReferralHistoryTable, ReferralLink } from "./ReferralSettings/index";

export const ReferralSettings: React.FC = () => {
  const loadSlug = useReferralStore((state) => state.loadSlug);
  const loadDashboard = useReferralStore((state) => state.loadDashboard);
  const isLoadingDashboard = useReferralStore(
    (state) => state.isLoadingDashboard
  );
  const dashboardError = useReferralStore((state) => state.dashboardError);
  const dashboard = useReferralStore((state) => state.dashboard);

  // Load data on mount
  useEffect(() => {
    loadSlug();
    loadDashboard();
  }, [loadSlug, loadDashboard]);

  // Show loading skeleton on initial load
  if (isLoadingDashboard && !dashboard) {
    return (
      <Stack gap="md">
        <Skeleton height={100} />
        <Skeleton height={200} />
        <Skeleton height={300} />
      </Stack>
    );
  }

  // Show error if dashboard failed to load
  if (dashboardError) {
    return (
      <Alert icon={<IconAlertCircle size={16} />} title="Error" color="red">
        Failed to load referral data. Please try again later.
      </Alert>
    );
  }

  return (
    <Stack gap="lg" p="lg">
      {/* 1. My Referral Link (includes customization and social share) */}
      <ReferralLink />

      {/* 2. Referral History (includes statistics) */}
      <ReferralHistoryTable />
    </Stack>
  );
};
